<div class="rule-feedback-container">
    <span class="feedback-legend">
    	<strong>Is this rule working for you?</strong> Let us know if anything is missing or could be improved.
    </span>
    <small>You can write up to 1000 characters.</small>
    <div class="rule-feedback-form-wrapper">
		<form [formGroup]="feedbackForm">
			<textarea pInputTextarea  formControlName="feedback"
				[maxlength]="1000"
				pInputText
				class="rule-feedback-input"
				[autoResize]="true"
				type="text"
				[placeholder]="success ? 'Thank you for your feedback!' : 'Write your feedback here...'">
			</textarea>
			<button
				class="feedback-send-btn"
				type="button"
				[ngClass]="{ 'i-gray': feedbackForm.invalid, 'i-blue': !feedbackForm.invalid }"
				[disabled]="feedbackForm.invalid || feedbackLoading"
				(click)="onFeedBackSend()">
				<i *ngIf="feedbackLoading" class="fa fa-spinner loading-spinner"></i>
				<i *ngIf="!feedbackLoading && !success" class="fa fa-paper-plane"></i>
				<i *ngIf="success" class="fa fa-circle-check"></i>
			</button>
		</form>
    </div>
    <div *ngIf="successMessage" class="fb-success-message">{{ successMessage }}</div>
	<div *ngIf="errorMessage" class="fb-error-message">{{ errorMessage }}</div>
  </div>
